import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/Login';
import DashboardPage from './pages/Dashboard';
import DocumentsPage from './pages/Documents';
import ReportRequestPage from './pages/ReportRequest';
import ReportConfirmationPage from './pages/ReportConfirmation';
import ReportPage from './pages/Report';
import SellPage from './pages/campaigns/SellPage';
import SellDivorcePage from './pages/campaigns/SellDivorcePage';
import SellInheritedPage from './pages/campaigns/SellInheritedPage';
import SellHealthPage from './pages/campaigns/SellHealthPage';
import SellDownsizingPage from './pages/campaigns/SellDownsizingPage';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/documents"
          element={
            <ProtectedRoute>
              <DocumentsPage />
            </ProtectedRoute>
          }
        />
        {/* Campaign landing pages */}
        <Route path="/sell" element={<SellPage />} />
        <Route path="/sell/divorce" element={<SellDivorcePage />} />
        <Route path="/sell/inherited" element={<SellInheritedPage />} />
        <Route path="/sell/health" element={<SellHealthPage />} />
        <Route path="/sell/downsizing" element={<SellDownsizingPage />} />
        {/* Public report flow */}
        <Route path="/report/request" element={<ReportRequestPage />} />
        <Route path="/report/:reportId/submitted" element={<ReportConfirmationPage />} />
        <Route path="/report/:reportId" element={<ReportPage />} />
      </Routes>
    </AuthProvider>
  );
}
